import React from 'react';
import createSvgIcon from '@mui/icons-material/utils/createSvgIcon';
import { styled } from '../styled';
import parseColor from '../util/parseColor';

const Icon = createSvgIcon(
  <svg viewBox='0 0 32 32' fill='none' color='inherit' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='m28.71,5.02l-2.86,3.06c-.06.06-.16.07-.22,0l-.58-.54s-.05-.08-.05-.13l.3-2.45c.02-.15-.17-.24-.27-.13l-1.23,1.32c-.06.06-.16.07-.22,0l-.65-.61c-.06-.06-.07-.16,0-.22l2.86-3.06c.06-.06.16-.07.22,0l.62.58s.05.08.05.13l-.28,2.35c-.02.15.17.24.27.13l1.18-1.26c.06-.06.16-.07.22,0l.65.61c.06.06.07.16,0,.22Z'
      fill='var(--mmm-logo-colors-north)'
    />
    <path
      d='m13.27,17.61c.6.24,1.08.71,1.35,1.3.64,1.43,1.88,4.23,2.64,6.07.23.55,1.02.5,1.18-.07l4.17-14.83c.14-.48-.32-.92-.8-.77l-14.68,4.68c-.57.18-.59.98-.03,1.19,1.88.7,4.71,1.84,6.16,2.43Z'
      fill='var(--mmm-logo-colors-arrow)'
    />
    <path
      d='m4.92,7.91c.12-.16.1-.38-.05-.51l-1.12-1.03c-.17-.15-.43-.13-.57.05-4.56,6.1-4.17,14.64.93,20.29.15.17.42.17.57,0l1.03-1.13c.13-.15.13-.36,0-.51C1.46,20.26,1.13,13.09,4.92,7.91Z'
      fill='var(--mmm-logo-colors-ring)'
    />
    <path
      d='m27.98,9.31c2.57,4.6,2.31,10.4-.89,14.78-.12.16-.1.38.05.51l1.12,1.03c.17.15.43.13.57-.05,3.94-5.27,4.18-12.34.89-17.82-.13-.22-.44-.26-.62-.06l-1.07,1.16c-.11.12-.13.31-.05.45Z'
      fill='var(--mmm-logo-colors-ring)'
    />
    <path
      d='m25.59,26.29c-.15-.13-.36-.13-.51,0-4.81,4.25-11.99,4.58-17.17.79-.16-.12-.38-.1-.51.05l-1.03,1.12c-.15.17-.13.43.05.57,6.1,4.56,14.64,4.17,20.29-.94.17-.15.17-.42,0-.57l-1.13-1.03Z'
      fill='var(--mmm-logo-colors-ring)'
    />
    <path
      d='m5.29,4.11c-.17.15-.17.42,0,.57l1.12,1.02c.15.13.37.13.52,0,4.04-3.57,9.75-4.37,14.55-2.29.15.07.33.03.44-.09l1.07-1.17c.18-.19.12-.5-.12-.61C17.13-1.18,10.15-.28,5.29,4.11Z'
      fill='var(--mmm-logo-colors-ring)'
    />
  </svg>,
  'Mmm',
);

export const defaultColors = {
  ring: '#223332',
  arrow: '#00cd83',
  north: '#ff6835',
};

const ColoredIcon = styled(Icon, {
  shouldForwardProp: (p) => p !== 'colors',
})(({ theme, colors: overrideColors = {} }) => {
  const colors = {
    ...defaultColors,
    ...overrideColors,
  };
  return ({
    '--mmm-logo-colors-north': parseColor(theme, colors.north),
    '--mmm-logo-colors-arrow': parseColor(theme, colors.arrow),
    '--mmm-logo-colors-ring': parseColor(theme, colors.ring),
  });
});

export default ColoredIcon;
